const appName = "MyCanvas";

enum Messages {
  WRONG_PAGE = "It seems like you're lost, mate...",
  ABOUT__FIRST_BLOCK = `Just a small application to enhance my understanding of certain technologies and libraries. `,
  ABOUT__SECOND_BLOCK = `React + Typescript + Redux-toolkit as a foundation, Styled-components for some styling, a few unit tests with the help of the React Testing Library and Jest-dom, and, obviously, a lot of canvas fun.`,
  ABOUT__THIRD_BLOCK = `A fully responsive application with mobile first philosophy.`,
  ABOUT__PARTING_WORDS = `Hope you're enjoing using it as much as I had creating it.`,
  HOME__BUTTON_TEXT = `Begin`,
  HOME__BUTTON_TEXT_ACTIVE = `Resume`,
  ERROR = "Sorry.. there was an error",
}

export { appName, Messages };
